<template>
  <div class="min-h-screen flex flex-col text-white bg-theme-tertiary">
    <router-view class="flex-grow" />
  </div>
</template>